// src/eventBus.js
import { reactive } from 'vue';

// Create a simple reactive object to use as the event bus
const eventBus = reactive({
  events: {},

  // Method to emit events
  emit(event, payload) {
    if (this.events[event]) {
      this.events[event].forEach(callback => callback(payload));
    }
  },

  // Method to listen for events
  on(event, callback) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
  },

  // Method to remove event listeners
  off(event, callback) {
    if (this.events[event]) {
      this.events[event] = this.events[event].filter(cb => cb !== callback);
    }
  }
});

export default eventBus;
